module.exports = __webpack_public_path__ + "img/upload-icon.c2cc49d5.svg";